<input type="checkbox" data-testid="shared-switch" id="{{ id }}" [checked]="value" (click)="toggleSwitch()" [disabled]="isDisabled" />
<label for="{{ id }}" class="checkbox-item" [ngClass]="switchClasses"></label>
